module.exports = __webpack_public_path__ + "media/images/emblems/Dallenwil-coat_of_arms-74e077d9aaaf8ab99e2976b5a1c1c036.svg";